import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../_common/Form/Buttons/Button';
import classes from './statusForm.module.scss';

const QAStatus = ({
  changeStatus, statusFill, statusShipped, statusRefill, statusReceived, setRefillModalData,
}) => {
  const setStatus = (status) => {
    if (status === 'Shipped') {
      setRefillModalData();
    } else {
      changeStatus({ status });
    }
  };

  return (
    <div className={classes.status_wrapper}>
      <p>
        {statusReceived
          ? ''
          : statusRefill
            ? 'Refill'
            : statusShipped
              ? 'Sign'
              : statusFill
                ? 'Verify the script and fill it.'
                : 'Verify the script and approve it to be filled.'}
      </p>

      <div className={classes.btns_wrapper}>
        <Button
          className={classes.max_content}
          title={statusReceived ? 'Ready to process' : statusRefill ? 'Receive'
            : statusShipped ? 'Signed' : statusFill ? 'Filled' : 'Approved'}
          approveButton={!statusFill && !statusShipped && !statusRefill && !statusReceived}
          fillButton={statusFill}
          signButton={statusShipped}
          receiveButton={statusRefill}
          processButton={statusReceived}
          onClick={() => setStatus(statusReceived ? 'Process' : statusRefill ? 'Received' : statusShipped ? 'Done'
            : statusFill ? 'Shipped' : 'Fill')}
        />

        {!statusShipped && (
          <Button
            className={classes.max_content}
            title="Flag for review"
            reviewButton
            onClick={() => setStatus('Review')}
          />
        )}
      </div>
    </div>
  );
};

QAStatus.propTypes = {
  changeStatus: PropTypes.func.isRequired,
  statusFill: PropTypes.bool,
  statusShipped: PropTypes.bool,
  statusRefill: PropTypes.bool,
  statusReceived: PropTypes.bool,
  setRefillModalData: PropTypes.func,
};

QAStatus.defaultProps = {
  statusFill: false,
  statusShipped: false,
  statusRefill: false,
  statusReceived: false,
  setRefillModalData: () => {},
};

export default QAStatus;
